import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProofSection() {
  return <section className="bg-navy-900 py-14 md:py-20 relative text-cream-50" data-id="element-284">
      <div className="container mx-auto px-4" data-id="element-285">
        <div className="max-w-[720px] mx-auto" data-id="element-286">
          <div className="flex items-center justify-center gap-3 mb-10" data-id="element-287">
            <div className="w-12 h-px bg-gold-500/30" data-id="element-288" />
            <div className="w-1.5 h-1.5 rotate-45 bg-gold-500/50" data-id="element-289" />
            <div className="w-12 h-px bg-gold-500/30" data-id="element-290" />
          </div>
          <FadeIn data-id="element-291">
            <div className="bg-navy-800 rounded-2xl p-8 md:p-10 shadow-xl border border-navy-700" data-id="element-292">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-8" data-id="element-293">
                Qué suele cambiar cuando ejecutas el protocolo de forma
                estricta:
              </h2>

              <ul className="space-y-6 text-lg text-cream-100/90 mb-8" data-id="element-294">
                <li className="flex items-start gap-4" data-id="element-295">
                  <div className="w-2 h-2 rounded-full bg-gold-500 mt-2.5 shrink-0" data-id="element-296" />
                  <p data-id="element-297">
                    En los primeros 3 días, muchos hombres reportan menos
                    urgencia nocturna y menos "alarmas" falsas.
                  </p>
                </li>
                <li className="flex items-start gap-4" data-id="element-298">
                  <div className="w-2 h-2 rounded-full bg-gold-500 mt-2.5 shrink-0" data-id="element-299" />
                  <p data-id="element-300">
                    En 7 días, es común notar menos despertares, mejor flujo y
                    más claridad mental al despertar.
                  </p>
                </li>
              </ul>

              <div className="bg-navy-900 p-6 rounded-xl border-l-4 border-gold-500" data-id="element-301">
                <p className="text-lg text-cream-100/90 font-medium" data-id="element-302">
                  Pero aquí va lo profesional: tu cuerpo no es una máquina
                  idéntica a la de otro hombre. Por eso incluimos diario y
                  sustituciones: para que lo aterrices a TU caso.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}